import { useEffect, useRef } from "react";
//#region src/hooks/usePrevious.ts
function usePrevious(value) {
	const ref = useRef(null);
	useEffect(() => {
		ref.current = value;
	}, [value]);
	return ref.current;
}
//#endregion
export { usePrevious };

//# sourceMappingURL=usePrevious.js.map